import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import * as fromVDTask from '../vd-state/reducers/vd.reducer';

@Component({
  selector: 'app-vd-steps-form-preview',
  templateUrl: './vd-steps-form-preview.component.html',
  styleUrls: ['./vd-steps-form-preview.component.scss']
})
export class VdStepsFormPreviewComponent implements OnInit {
  selectedStep = null;
  stepsForm: FormGroup = new FormGroup({});
  stepsFormData;
  @Input()
  htmlRenderObj: any[];
  addForm = new FormGroup({});
  visaInfo: any;
  prePDFToWorkflow: boolean;

  constructor(
    private store: Store<any>
  ) {
    combineLatest([
      this.store.select(fromVDTask.getVDVisaInfo),
      this.store.select(fromVDTask.getVDBuildType)
    ])
      .pipe(take(1))
      .subscribe((response: any[]) => {
        this.visaInfo = response[0];
        this.prePDFToWorkflow = response[1] && response[1] === 'old';
      });
  }

  ngOnInit(): void {
    this.selectedStep = JSON.parse(localStorage.getItem('selectedStep'));
  }
  ngOnChanges(e: SimpleChanges) {
    if (e.htmlRenderObj && e.htmlRenderObj.currentValue) {
      this.stepsFormData = e.htmlRenderObj.currentValue;
    }
  }

}
